import { Debug, Utils, ReduxSagaRequest, Request } from "@hlibs/index";
import Language from "@app/language";

export const List = async (callback, reduxModule) => {
  const stateKey = "List";

  try {
    const response = await Request.get("/advertiser/list");
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "advertiser");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Info = async (payload, callback, reduxModule) => {
  const stateKey = "Info";

  if (Utils.checkNullOrEmpty(payload, payload.code))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.get("/advertiser/info", {
      code: payload.code,
    });
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "ad");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Add = async (payload, callback, reduxModule) => {
  const stateKey = "Add";
  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.post("/advertiser/info", {
      name: payload.name,
      code: payload.code,
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Update = async (payload, callback, reduxModule) => {
  const stateKey = "Update";
  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.patch("/advertiser/info", {
      name: payload.name,
      advertiser_id: payload.code,
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};
